import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Grid,
  Avatar,
  makeStyles,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  gridItem: {
    textAlign: "left",
  },
  valueText: {
    marginTop: theme.spacing(1),
  },
}));

const UpdateSuccessDialog = (props) => {
  const { openDialog, updatedData, handleCloseSuccessDialog, adminDetails } =
    props;

  const classes = useStyles();

  return (
    <Dialog open={openDialog} maxWidth="sm" fullWidth>
      <DialogContent className={classes.dialogContent}>
        <CheckCircleIcon className={classes.avatar} />

        <Typography variant="h6" style={{ marginTop: "10px" }}>
          Sponsor Details Updated
        </Typography>
        <Typography variant="body1" style={{ marginTop: "10px" }}>
          { "The Sponsor details have been updated successfully"}
        </Typography>

        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={handleCloseSuccessDialog}
          >
            OK
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateSuccessDialog;
